<template lang="html">
    <div class="default-page-paddings">
        <div class="container container-medium article">
            <Heading :title="$t('about') + ' ' + capitalize($t('us'))" :routeName="'vignette'" :alignment="'text-left'"></Heading>
            <div class="default-content reading" v-if="locale == 'ro'">
                <p>Site-ul <router-link :to="{name: 'vignette'}">E-rovinieta</router-link> este deținut de Uniunea Națională a Transportatorilor Rutieri din România (UNTRR).</p>

                <p>UNTRR este o organizație profesională și patronală, neguvernamentală, independentă, apolitică, fondată în 1990 pe principii democratice, care promovează și apără interesele transportatorilor rutieri pe plan intern și internațional.</p>

                <p><strong>Misiunea si viziunea <router-link :to="{name: 'vignette'}">E-rovinieta</router-link></strong></p>

                <p>
                    Platforma <router-link :to="{name: 'vignette'}">E-rovinieta</router-link> urmărește să fie liderul în furnizarea serviciului online de
                    cumpărare a rovinietei pentru utilizatorii persoane fizice și juridice. Misiunea noastră este de a
                    oferi clienților cea mai bună experiență de cumpărare a rovinietei și de a-i ajuta în respectarea
                    legislației privind regimul de taxare al drumurilor din România.
                </p>

                <p>
                    UNTRR și platforma <router-link :to="{name: 'vignette'}">E-rovinieta</router-link> sunt parteneri de încredere pentru posesorii de
                    autovehicule din România și ne propunem să le oferim servicii cu valoare adăugată pentru a le
                    economisi timp și pentru a-i ajuta în activitatea zilnică.
                </p>

                <p><b>Valorile <router-link :to="{name: 'vignette'}">E-rovinieta</router-link></b></p>

                <ul>
                    <li>Excelență operațională</li>
                    <li>Inovație</li>
                    <li>Responsabilitate</li>
                    <li>Colaborare</li>
                </ul>
            </div>
            <div class="default-content reading" v-else>
                <p>The website <router-link :to="{name: 'vignette'}">E-rovinieta</router-link> is owned by the National Union of Road Hauliers from Romania (UNTRR).</p>

                <p>UNTRR is an organisation - professional and employers, non-governmental, independent, apolitical - founded in 1990 on democratic principles, promoting and defending the interests of road transport domestically and internationally.</p>

                <p><b>Mission and vision statements</b></p>

                <p>
                    The platform <router-link :to="{name: 'vignette'}">E-rovinieta</router-link> aims to be the leader in providing the online service for buying
                    vignettes for individuals and legal entities. Our mission is to offer customers the best shopping
                    experience and to help them comply with the Romanian legislation about tolling.<br/><br/>
                    UNTRR and the platform <router-link :to="{name: 'vignette'}">E-rovinieta</router-link> are reliable partners for vehicle owners and we aim to
                    offer value-added services to save time and help them in their daily activities.
                </p>

                <p><b>The values of E-rovinieta.ro</b></p>

                <ul>
                    <li>Operational excellence</li>
                    <li>Innovation</li>
                    <li>Responsibility</li>
                    <li>Collaboration</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

import Heading from './snippets/Heading.vue'
import { mapState } from 'vuex'

export default {
    name: 'AboutUs',
    components: {
        Heading
    },
    props: {
    },
    computed: {
        ...mapState('language', [
            'locale'
        ])
    }
}

</script>

<style lang="css" scoped>

</style>
